import { UserPermission } from '../../permission/enum';
export const licenseRoutes = [
    {
        path: '',
        name: 'License',
        exact: true,
        component: () => import('../views/LicenseIndex.vue'),
        meta: {
            breadcrumb: [{ label: 'All Licenses' }],
            permissions: [UserPermission.READ_LICENCE, UserPermission.READ_PRODUCT],
        },
    },
];
